import { provideAppInitializer } from '@angular/core';

import { onSessionEnd } from './on-session-end';

const isViewerToolStyle = (key: string) =>
  key.startsWith('toolData-') || key.includes('-toolData-');

export const clearUserBrowserStorage = () => {
  Object.keys(window.localStorage)
    .filter(isViewerToolStyle)
    .forEach((key) => window.localStorage.removeItem(key));
  window.sessionStorage.removeItem('planInfo');
};

export const provideBrowserStorageCleanup = () =>
  provideAppInitializer(() => {
    onSessionEnd(clearUserBrowserStorage);
  });
